import httpStore from "@/api/httpStore.js";

export function getProducts(filters) {
  return httpStore
    .get("/products", { params: filters })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function simpleSearchProducts(q, limit = 50, cancelToken) {
  return httpStore
    .get("/products/simple_search", {
      params: { q, limit },
      ...(cancelToken ? { cancelToken } : {})
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}
export function getProduct(code) {
  return httpStore
    .get(`/products/single/${code}`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}
// Borra un producto huérfano local (solo en part_info_local, no en el maestro).
export function deleteLocalProduct(code) {
  return httpStore
    .delete(`/products?nkr_code=${encodeURIComponent(code)}`)
    .then(res => res.data);
}
export function getProductImages(code) {
  return httpStore
    .get(`/products/images/${code}`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}
export function changeProductStatus(code, status) {
  return httpStore
    .get(`/products/change_status/${code}/${status}`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function updateProduct(product) {
  return httpStore
    .put(`/products`, { product })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function createProduct(
  nkrCode,
  oe,
  unificado,
  dependencia = "A",
  brand = "",
  listPrice = 0
) {
  return httpStore
    .post(`/products`, {
      nkrCode,
      oe,
      unificado,
      dependencia,
      brand,
      listPrice
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// Reindexa un producto: el endpoint publica product_updated_event, que
// search-sync lleva a Typesense. Conserva el nombre de cuando era de Algolia.
export function updateSearchProduct(code) {
  return httpStore
    .get(`/products/algolia_update/${code}`)
    .then(res => res.data);
}

// Typesense (search-sync): cada modo con su propio procedure_name. El
// resultado lo escribe search-sync en async_procedures.
export function updateTypesenseAllProducts() {
  return httpStore.get(`/products/typesense_update_all`).then(res => res.data);
}

export function syncTypesenseDeltaPrice() {
  return httpStore
    .get(`/products/typesense_sync_delta_price`)
    .then(res => res.data);
}

export function syncTypesenseDeltaFull() {
  return httpStore
    .get(`/products/typesense_sync_delta_full`)
    .then(res => res.data);
}

export function clearTypesenseIndex() {
  return httpStore.get(`/products/typesense_clear_index`).then(res => res.data);
}

// Vehículos (colección <tienda>_vehicles, search-sync src/vehicles): la tabla
// entera con sus familias. Lo usa la búsqueda de productos para reconocer el
// vehículo en lo escrito.
export function syncTypesenseVehicles() {
  return httpStore
    .get(`/products/typesense_sync_vehicles`)
    .then(res => res.data);
}

export function getProductsSoldTogether(code) {
  return httpStore
    .get(`/products_sold_together/single/${code}`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function updateSoldTogetherRelation(code, relatedCode, manualAverage) {
  return httpStore
    .put(`/products_sold_together/update`, {
      code,
      relatedCode,
      manualAverage
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function deleteSoldTogetherRelation(code, relatedCode) {
  return httpStore
    .delete(
      `/products_sold_together/delete?code=${code}&relatedCode=${relatedCode}`
    )
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}
export function createSoldTogether(code, relatedCode) {
  return httpStore
    .post(`/products_sold_together/create`, {
      code,
      relatedCode
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}
export function recalculateProductsSoldTogether(code) {
  return httpStore
    .get(`/products_sold_together/recalculate/${code}`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function loadKitItems(code) {
  return httpStore.get(`/products_kits/items/${code}`).then(res => res.data);
}

export function deleteKitItem(code, itemCode) {
  return httpStore
    .delete(`/products_kits/item/${code}/${itemCode}`)
    .then(res => res.data);
}

export function addKitItem(kitCode, item) {
  return httpStore
    .post(`/products_kits/item/${kitCode}`, { item })
    .then(res => res.data);
}

export function updateKitItem(kitCode, item) {
  return httpStore
    .put(`/products_kits/item/${kitCode}`, { item })
    .then(res => res.data);
}

export function getKitsRelatedToProduct(code) {
  return httpStore
    .get(`/products_kits/related_to_product/${code}`)
    .then(res => res.data);
}

export function getNextAvailable(code) {
  return httpStore.get(`/products/next_available/${code}`).then(res => {
    console.log(res.data);
    return res.data.code;
  });
}

export function copyTitlesFromInfoauto() {
  return httpStore
    .get(`/products/copy_titles_from_infoauto`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function getVehicleBrands() {
  return httpStore
    .get(`/products/brands_vehicles_infoauto`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function getBrands() {
  return httpStore
    .get(`/brands`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function getDependencyOptions() {
  return httpStore
    .get(`/products/dependency_options`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function getPriceGroups() {
  return httpStore
    .get(`/products/price_groups`)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}
